import React, { useContext, useState } from 'react'
import { M_Table, M_MessageBoard, M_Button, LoadingContext, BufferService, NavigateContext } from 'src/M_Components'
import { useTranslation } from 'react-i18next'

export const TradeList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const [refresh, setRefresh] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
    const [tradeToDelete, setTradeToDelete] = useState()
    const tradeService = new BufferService('Trade')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const NewRoute = (operation, data) => {
        ctx.passValue?.set('operation', operation)

        if (operation === 'create') {
            ctx2.newTab('go/tradeDetail', t("CreateTrade"))
            return
        }

        if (!data && selectedRows.length === 0) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }

        if (operation === 'edit') {
            ctx.passValue.set('Row', data)
            ctx.passValue.set('Rows', selectedRows && selectedRows.length > 0 ? selectedRows : [data])
            ctx2.newTab('go/tradeDetail', t("EditTrade"))
        }

        if (operation === 'view') {
            ctx.passValue.set('Row', data)
            ctx2.newTab('go/tradeDetail', t("ViewTrade"))
        }

        if (operation === 'copy') {
            ctx.passValue.set('Row', data)
            ctx2.newTab('go/tradeDetail', t("CopyTrade"))
        }
    }

    const deleteTrade = (data) => {
        if (!data) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        const id = Array.isArray(data) ? data[data.length - 1].Id : data.Id
        tradeService.delete(id).then(resData => {
            if (resData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorQuote"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessTradeDeleted"))
            setRefresh(true)
            setOpenDeleteDialog(false)
        })
    }

    return (
        <div className='backgroundForms'>
            <div>
                <M_Table
                    roleName={'trade'}
                    filtersOnTable
                    entityName={'Trade'}
                    tablesOrder={tablesOrder}
                    pageUrl={'Trade'}
                    onTablesOrderUpdate={onTablesOrderUpdate}
                    removeContextItems={[]}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    rolePermissions={roles}
                    replaceFunctions={new Map([
                        ['Delete', (data) => {
                            setTradeToDelete(data)
                            setOpenDeleteDialog(true)
                        }],
                        ['Create', (data) => NewRoute('create', data)],
                        ['Edit', (data) => NewRoute('edit', data)],
                        ['View', (data) => NewRoute('view', data)],
                        ['Copy', (data) => NewRoute('copy', data)]
                    ])}
                    onPassLine={(rows) => setSelectedRows(rows)}
                />
            </div>
            <div className='dividerTables'></div>
            <M_MessageBoard
                warning
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                title={`${t("Delete")} ${t("Trade")}?`}
                body={<span>{t("TitleConfirmDelete")} <b>{t("Trade")}</b></span>}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-grey)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenDeleteDialog(false)}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t("Delete")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteTrade(tradeToDelete)}
                        />
                    </div>
                }
            />
        </div>
    )
}
